
// import React, { useContext } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   Grid,
//   Container,
//   Avatar
// } from "@mui/material";

// import PersonIcon from "@mui/icons-material/Person";
// import BusinessIcon from "@mui/icons-material/Business";
// import LocationCityIcon from "@mui/icons-material/LocationCity";
// import HomeIcon from "@mui/icons-material/Home";
// import SolarPowerIcon from "@mui/icons-material/SolarPower";
// import PublicIcon from "@mui/icons-material/Public";
// import LockIcon from "@mui/icons-material/Lock";
// import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
// import { MdViewModule } from "react-icons/md";

// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { AuthenticationContext } from "../../../../context/AuthenticationContext";
// import TopHeader from '../../../../components/general/TopHeader';

// const UserDetails = () => {

//   const { PrimaryColor } = useContext(AppThemeContext);
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);

//   const LOGIN_ID = sessionStorage.getItem("LoginID");
//   const PW = sessionStorage.getItem("PW");

//   const userData = {
//     user_id: LOGIN_ID,
//     username: LoggedInUserInfo?.username,
//     plant_capacity: LoggedInUserInfo?.PLANT_CAPACITY,
//     dc_capacity: LoggedInUserInfo?.DC_CAPACITY,
//     address: LoggedInUserInfo?.Address,
//     city: LoggedInUserInfo?.city,
//     currency: LoggedInUserInfo?.CURRENCY,
//     lat: LoggedInUserInfo?.LATITUDE,
//     long: LoggedInUserInfo?.LONGITUDE,
//     rate: LoggedInUserInfo?.rate,
//     co2_rate: LoggedInUserInfo?.co2,
//     total_modules: LoggedInUserInfo?.TOTAL_NO_MODULE,
//     module_capacity: LoggedInUserInfo?.EACH_MODULE_CAPACITY,
//     password: PW,
//     moudle_make:LoggedInUserInfo?.MODULE_MAKE,

//   };

//   const field = (label, value, icon) => (
//     <Grid item xs={12} sm={6} md={4}>
//       <Paper
//         elevation={4}
//         sx={{
//           p: 2,
//           borderRadius: 3,
//           display: "flex",
//           alignItems: "center",
//           gap: 2,
//           transition: "0.3s",
//           "&:hover": {
//             transform: "translateY(-6px)",
//             boxShadow: 8
//           }
//         }}
//       >

//         <Avatar
//           sx={{
//             background: `linear-gradient(135deg, ${PrimaryColor}, ${PrimaryColor}99)`
//           }}
//         >
//           {icon}
//         </Avatar>

//         <Box>
//           <Typography
//             variant="caption"
//             sx={{ color: "gray", fontWeight: 600 }}
//           >
//             {label}
//           </Typography>

//           <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
//             {value || "-"}
//           </Typography>
//         </Box>

//       </Paper>
//     </Grid>
//   );

//   return (
//     <>
//     {/* <TopHeader /> */}
//      <Container maxWidth="lg">

//       <Box sx={{ mt: 5 }}>

//         {/* Header Card */}

//         <Paper
//           elevation={6}
//           sx={{
//             p: 3,
//             mb: 4,
//             borderRadius: 4,
//             textAlign: "center",
//             background: `linear-gradient(135deg, ${PrimaryColor}, ${PrimaryColor}99)`,
//             color: "white"
//           }}
//         >

//           <Avatar
//             sx={{
//               width: 70,
//               height: 70,
//               margin: "auto",
//               mb: 1,
//               bgcolor: "white",
//               color: PrimaryColor
//             }}
//           >
//             <PersonIcon fontSize="large" />
//           </Avatar>

//           <Typography variant="h5" sx={{ fontWeight: "bold" }}>
//             User Details
//           </Typography>

//           <Typography variant="body2">
//             {/* Solar Plant User Information */}
//           </Typography>

//         </Paper>

//         {/* Detail Cards */}

//         <Grid container spacing={3}>

//           {field("User ID", userData.user_id, <PersonIcon />)}
//           {field("User Name", userData.username, <PersonIcon />)}
//           {field("Plant Capacity", userData.plant_capacity, <SolarPowerIcon />)}
//           {field("DC Capacity", userData.dc_capacity, <SolarPowerIcon />)}
//           {field("Address", userData.address, <HomeIcon />)}
//           {field("City", userData.city, <LocationCityIcon />)}
//           {field("Currency", userData.currency, <PublicIcon />)}
//           {field("Latitude", userData.lat, <PublicIcon />)}
//           {field("Longitude", userData.long, <PublicIcon />)}
//           {field("Rate", userData.rate, <BusinessIcon />)}
//           {field("CO2 Reduction ", userData.co2_rate, <SolarPowerIcon />)}
//           {field("Total Number Modules", userData.total_modules, <SettingsInputComponentIcon />)}
//           {field("Each Module Capacity", userData.module_capacity, <SettingsInputComponentIcon />)}
//           {field("Password", userData.password, <LockIcon />)}
//           {field("Module Make", userData.moudle_make, <MdViewModule />)}

//         </Grid>

//       </Box>

//     </Container>
//     <button>Update Form</button>
//     </>

//   );
// };

// export default UserDetails;

// 2.

// import React, { useContext, useState } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   Grid,
//   Container,
//   Avatar,
//   Button
// } from "@mui/material";

// import PersonIcon from "@mui/icons-material/Person";
// import BusinessIcon from "@mui/icons-material/Business";
// import LocationCityIcon from "@mui/icons-material/LocationCity";
// import HomeIcon from "@mui/icons-material/Home";
// import SolarPowerIcon from "@mui/icons-material/SolarPower";
// import PublicIcon from "@mui/icons-material/Public";
// import LockIcon from "@mui/icons-material/Lock";
// import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
// import { MdViewModule } from "react-icons/md";

// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { AuthenticationContext } from "../../../../context/AuthenticationContext";

// // 👇 import update modal

// import UserDetailUpdate from "./UserDetailUpdate";

// const UserDetails = () => {

//   const { PrimaryColor } = useContext(AppThemeContext);
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);

//   const [openUpdate, setOpenUpdate] = useState(false);

//   const LOGIN_ID = sessionStorage.getItem("LoginID");
//   const PW = sessionStorage.getItem("PW");

//   const userData = {
//     user_id: LOGIN_ID,
//     username: LoggedInUserInfo?.username,
//     plant_capacity: LoggedInUserInfo?.PLANT_CAPACITY,
//     dc_capacity: LoggedInUserInfo?.DC_CAPACITY,
//     address: LoggedInUserInfo?.Address,
//     city: LoggedInUserInfo?.city,
//     currency: LoggedInUserInfo?.CURRENCY,
//     lat: LoggedInUserInfo?.LATITUDE,
//     long: LoggedInUserInfo?.LONGITUDE,
//     rate: LoggedInUserInfo?.rate,
//     co2_rate: LoggedInUserInfo?.co2,
//     total_modules: LoggedInUserInfo?.TOTAL_NO_MODULE,
//     module_capacity: LoggedInUserInfo?.EACH_MODULE_CAPACITY,
//     password: PW,
//     moudle_make: LoggedInUserInfo?.MODULE_MAKE,
//   };

//   const field = (label, value, icon) => (
//     <Grid item xs={12} sm={6} md={4}>
//       <Paper
//         elevation={4}
//         sx={{
//           p: 2,
//           borderRadius: 3,
//           display: "flex",
//           alignItems: "center",
//           gap: 2,
//           transition: "0.3s",
//           "&:hover": {
//             transform: "translateY(-6px)",
//             boxShadow: 8
//           }
//         }}
//       >

//         <Avatar
//           sx={{
//             background: `linear-gradient(135deg, ${PrimaryColor}, ${PrimaryColor}99)`
//           }}
//         >
//           {icon}
//         </Avatar>

//         <Box>
//           <Typography variant="caption" sx={{ color: "gray", fontWeight: 600 }}>
//             {label}
//           </Typography>

//           <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
//             {value || "-"}
//           </Typography>
//         </Box>

//       </Paper>
//     </Grid>
//   );

//   return (
//     <>
//       <Container maxWidth="lg">

//         <Box sx={{ mt: 5 }}>

//           {/* Header */}
//           <Paper
//             elevation={6}
//             sx={{
//               p: 3,
//               mb: 4,
//               borderRadius: 4,
//               textAlign: "center",
//               background: `linear-gradient(135deg, ${PrimaryColor}, ${PrimaryColor}99)`,
//               color: "white"
//             }}
//           >

//             <Avatar
//               sx={{
//                 width: 70,
//                 height: 70,
//                 margin: "auto",
//                 mb: 1,
//                 bgcolor: "white",
//                 color: PrimaryColor
//               }}
//             >
//               <PersonIcon fontSize="large" />
//             </Avatar>

//             <Typography variant="h5" sx={{ fontWeight: "bold" }}>
//               User Details
//             </Typography>

//           </Paper>

//           {/* Data Cards */}
//           <Grid container spacing={3}>
//             {field("User ID", userData.user_id, <PersonIcon />)}
//             {field("User Name", userData.username, <PersonIcon />)}
//             {field("Plant Capacity", userData.plant_capacity, <SolarPowerIcon />)}
//             {field("DC Capacity", userData.dc_capacity, <SolarPowerIcon />)}
//             {field("Address", userData.address, <HomeIcon />)}
//             {field("City", userData.city, <LocationCityIcon />)}
//             {field("Currency", userData.currency, <PublicIcon />)}
//             {field("Latitude", userData.lat, <PublicIcon />)}
//             {field("Longitude", userData.long, <PublicIcon />)}
//             {field("Rate", userData.rate, <BusinessIcon />)}
//             {field("CO2 Reduction", userData.co2_rate, <SolarPowerIcon />)}
//             {field("Total Modules", userData.total_modules, <SettingsInputComponentIcon />)}
//             {field("Each Module Capacity", userData.module_capacity, <SettingsInputComponentIcon />)}
//             {field("Password", userData.password, <LockIcon />)}
//             {field("Module Make", userData.moudle_make, <MdViewModule />)}
//           </Grid>

//           {/* ✅ UPDATE BUTTON */}
//           <Box sx={{ textAlign: "center", mt: 4 }}>
//             <Button
//               variant="contained"
//               onClick={() => setOpenUpdate(true)}
//               sx={{
//                 backgroundColor: PrimaryColor,
//                 px: 4,
//                 py: 1.8,
//                 borderRadius: 1
//               }}
//             >
//               Update User Details
//             </Button>
//           </Box>

//         </Box>
//       </Container>

//       {/* ✅ UPDATE MODAL */}
//       <UserDetailUpdate
//         show={openUpdate}
//         handleClose={() => setOpenUpdate(false)}
//         userData={userData}
//         onUpdate={(data) => {
//           console.log("Updated Successfully:", data);
//         }}
//       />
//     </>
//   );
// };

// export default UserDetails;

// 3. modify red color  (ye correct code hai login api se data ata hai)

// import React, { useContext, useState } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   Grid,
//   Container,
//   Avatar,
//   Button
// } from "@mui/material";

// import PersonIcon from "@mui/icons-material/Person";
// import BusinessIcon from "@mui/icons-material/Business";
// import LocationCityIcon from "@mui/icons-material/LocationCity";
// import HomeIcon from "@mui/icons-material/Home";
// import SolarPowerIcon from "@mui/icons-material/SolarPower";
// import PublicIcon from "@mui/icons-material/Public";
// import LockIcon from "@mui/icons-material/Lock";
// import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";
// import { MdViewModule } from "react-icons/md";

// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { AuthenticationContext } from "../../../../context/AuthenticationContext";

// import UserDetailUpdate from "./UserDetailUpdate";

// const UserDetails = () => {

//   const { PrimaryColor } = useContext(AppThemeContext);
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);

//   const [openUpdate, setOpenUpdate] = useState(false);

//   const LOGIN_ID = sessionStorage.getItem("LoginID");
//   const PW = sessionStorage.getItem("PW");

//   const userData = {
//     user_id: LOGIN_ID,
//     username: LoggedInUserInfo?.username,
//     plant_capacity: LoggedInUserInfo?.PLANT_CAPACITY,
//     dc_capacity: LoggedInUserInfo?.DC_CAPACITY,
//     address: LoggedInUserInfo?.Address,
//     city: LoggedInUserInfo?.city,
//     currency: LoggedInUserInfo?.CURRENCY,
//     lat: LoggedInUserInfo?.LATITUDE,
//     long: LoggedInUserInfo?.LONGITUDE,
//     rate: LoggedInUserInfo?.rate,
//     co2_rate: LoggedInUserInfo?.co2,
//     total_modules: LoggedInUserInfo?.TOTAL_NO_MODULE,
//     module_capacity: LoggedInUserInfo?.EACH_MODULE_CAPACITY,
//     password: PW,
//     moudle_make: LoggedInUserInfo?.MODULE_MAKE,
//   };

//   // ✅ UPDATED FIELD FUNCTION WITH COLOR SUPPORT
//   const field = (label, value, icon, valueColor = "black") => (
//     <Grid item xs={12} sm={6} md={4}>
//       <Paper
//         elevation={4}
//         sx={{
//           p: 2,
//           borderRadius: 3,
//           display: "flex",
//           alignItems: "center",
//           gap: 2,
//           transition: "0.3s",
//           "&:hover": {
//             transform: "translateY(-6px)",
//             boxShadow: 8
//           }
//         }}
//       >

//         <Avatar
//           sx={{
//             background: `linear-gradient(135deg, ${PrimaryColor}, ${PrimaryColor}99)`
//           }}
//         >
//           {icon}
//         </Avatar>

//         <Box>
//           <Typography
//             variant="caption"
//             sx={{ color: "gray", fontWeight: 600 }}
//           >
//             {label}
//           </Typography>

//           <Typography
//             variant="subtitle1"
//             sx={{
//               fontWeight: "bold",
//               color: valueColor
//             }}
//           >
//             {value || "-"}
//           </Typography>
//         </Box>

//       </Paper>
//     </Grid>
//   );

//   return (
//     <>
//       <Container maxWidth="lg">

//         <Box sx={{ mt: 5 }}>

//           {/* HEADER */}
//           <Paper
//             elevation={6}
//             sx={{
//               p: 3,
//               mb: 4,
//               borderRadius: 4,
//               textAlign: "center",
//               background: `linear-gradient(135deg, ${PrimaryColor}, ${PrimaryColor}99)`,
//               color: "white"
//             }}
//           >

//             <Avatar
//               sx={{
//                 width: 70,
//                 height: 70,
//                 margin: "auto",
//                 mb: 1,
//                 bgcolor: "white",
//                 color: PrimaryColor
//               }}
//             >
//               <PersonIcon fontSize="large" />
//             </Avatar>

//             <Typography variant="h5" sx={{ fontWeight: "bold" }}>
//               User Details
//             </Typography>

//           </Paper>

//           {/* DATA CARDS */}
//           <Grid container spacing={3}>
//             {field("User ID", userData.user_id, <PersonIcon />)}
//             {field("User Name", userData.username, <PersonIcon />)}
//             {field("Plant Capacity", userData.plant_capacity, <SolarPowerIcon />)}
//             {field("DC Capacity", userData.dc_capacity, <SolarPowerIcon />)}
//             {field("Address", userData.address, <HomeIcon />)}
//             {field("City", userData.city, <LocationCityIcon />)}
//             {field("Currency", userData.currency, <PublicIcon />)}
//             {field("Latitude", userData.lat, <PublicIcon />)}
//             {field("Longitude", userData.long, <PublicIcon />)}

//             {/* ✅ RED COLOR FIELDS */}
//             {field("Rate", userData.rate, <BusinessIcon />, "#d32f2f")}
//             {field("CO2 Reduction", userData.co2_rate, <SolarPowerIcon />, "#d32f2f")}

//             {field("Total Modules", userData.total_modules, <SettingsInputComponentIcon />)}
//             {field("Each Module Capacity", userData.module_capacity, <SettingsInputComponentIcon />)}
//             {field("Password", userData.password, <LockIcon />)}
//             {field("Module Make", userData.moudle_make, <MdViewModule />)}
//           </Grid>

//           {/* UPDATE BUTTON */}
//           <Box sx={{ textAlign: "center", mt: 4 }}>
//             <Button
//               variant="contained"
//               onClick={() => setOpenUpdate(true)}
//               sx={{
//                 backgroundColor: PrimaryColor,
//                 px: 4,
//                 py: 1.8,
//                 borderRadius: 1
//               }}
//             >
//               Update User Details
//             </Button>
//           </Box>

//         </Box>
//       </Container>

//       {/* UPDATE MODAL */}
//       <UserDetailUpdate
//         show={openUpdate}
//         handleClose={() => setOpenUpdate(false)}
//         userData={userData}
//         onUpdate={(data) => {
//           console.log("Updated Successfully:", data);
//         }}
//       />
//     </>
//   );
// };

// export default UserDetails; 


// 4.


// import React, { useContext, useState, useEffect } from "react";
// import {
//   Box,
//   Paper,
//   Typography,
//   Grid,
//   Container,
//   Avatar,
//   Button
// } from "@mui/material";

// import PersonIcon from "@mui/icons-material/Person";
// import BusinessIcon from "@mui/icons-material/Business";
// import LocationCityIcon from "@mui/icons-material/LocationCity";
// import HomeIcon from "@mui/icons-material/Home";
// import SolarPowerIcon from "@mui/icons-material/SolarPower";
// import PublicIcon from "@mui/icons-material/Public";
// import LockIcon from "@mui/icons-material/Lock";
// import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";

// import { MdViewModule } from "react-icons/md";

// import { AppThemeContext } from "../../../../context/AppThemeContext";
// import { AuthenticationContext } from "../../../../context/AuthenticationContext";

// import UserDetailUpdate from "./UserDetailUpdate";
// import { UserDetailApi } from "../../../../api/Api";

// const UserDetails = () => {
//   const { PrimaryColor } = useContext(AppThemeContext);
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);

//   const [logData, setLogData] = useState({});
//   const [openUpdate, setOpenUpdate] = useState(false);

//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   const LOGIN_ID = sessionStorage.getItem("LoginID") || "";
// const PW = sessionStorage.getItem("PW") || "";

//   const credentials = {
//     LOGIN_ID: LOGIN_ID,
//     PASS_KEY: "xyz",
//     WEB_KEY: "xyz",
//   };

//   // FETCH USER DATA
//   const fetchLogData = async () => {
//     setLoading(true);
//     setError("");

//     try {
//       const res = await UserDetailApi(credentials);

//       console.log("API RESPONSE:", res);

//       if (res?.USER_DET) {
//         // if array
//         if (Array.isArray(res.USER_DET)) {
//           setLogData(res.USER_DET[0] || {});
//         } else {
//           // if object
//           setLogData(res.USER_DET);
//         }
//       } else {
//         setLogData({});
//       }
//     } catch (err) {
//       console.log(err);
//       setError("Failed to fetch data");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, []);

//   const userData = {
//     user_id: LOGIN_ID,
//     username: logData?.USER_NAME,
//     plant_capacity: logData?.PLANT_CAPACITY,
//     dc_capacity: logData?.DC_CAPACITY,
//     address: logData?.ADDRESS,
//     city: logData?.CITY,
//     currency: logData?.CURRENCY,
//     lat: logData?.LATITUDE,
//     long: logData?.LONGITUDE,
//     rate: logData?.RATE,
//     co2_rate: logData?.CO2,
//     total_modules: logData?.TOTAL_NO_MODULE,
//     module_capacity: logData?.EACH_MODULE_CAPACITY,
//     password: PW,
//     module_make: logData?.MODULE_MAKE,
//   };

//   // FIELD CARD
//   const field = (label, value, icon, valueColor = "black") => (
//     <Grid item xs={12} sm={6} md={4}>
//       <Paper
//         elevation={4}
//         sx={{
//           p: 2,
//           borderRadius: 3,
//           display: "flex",
//           alignItems: "center",
//           gap: 2,
//           transition: "0.3s",
//           height: "100%",
//           "&:hover": {
//             transform: "translateY(-6px)",
//             boxShadow: 8,
//           },
//         }}
//       >
//         <Avatar
//           sx={{
//             background: `linear-gradient(135deg, ${PrimaryColor}, ${PrimaryColor}99)`,
//           }}
//         >
//           {icon}
//         </Avatar>

//         <Box>
//           <Typography
//             variant="caption"
//             sx={{ color: "gray", fontWeight: 600 }}
//           >
//             {label}
//           </Typography>

//           <Typography
//             variant="subtitle1"
//             sx={{
//               fontWeight: "bold",
//               color: valueColor,
//               wordBreak: "break-word",
//             }}
//           >
//             {value || "-"}
//           </Typography>
//         </Box>
//       </Paper>
//     </Grid>
//   );

//   return (
//     <>
//       <Container maxWidth="lg">
//         <Box sx={{ mt: 5 }}>
//           {/* HEADER */}
//           <Paper
//             elevation={6}
//             sx={{
//               p: 3,
//               mb: 4,
//               borderRadius: 4,
//               textAlign: "center",
//               background: `linear-gradient(135deg, ${PrimaryColor}, ${PrimaryColor}99)`,
//               color: "white",
//             }}
//           >
//             <Avatar
//               sx={{
//                 width: 70,
//                 height: 70,
//                 margin: "auto",
//                 mb: 1,
//                 bgcolor: "white",
//                 color: PrimaryColor,
//               }}
//             >
//               <PersonIcon fontSize="large" />
//             </Avatar>

//             <Typography variant="h5" sx={{ fontWeight: "bold" }}>
//               User Details
//             </Typography>
//           </Paper>

//           {/* LOADING */}
//           {loading && (
//             <Typography textAlign="center">Loading...</Typography>
//           )}

//           {/* ERROR */}
//           {error && (
//             <Typography color="error" textAlign="center">
//               {error}
//             </Typography>
//           )}

//           {/* DATA CARDS */}
//           {!loading && (
//             <Grid container spacing={3}>
//               {field("User ID", userData.user_id, <PersonIcon />)}
//               {field("User Name", userData.username, <PersonIcon />)}
//               {field(
//                 "Plant Capacity",
//                 userData.plant_capacity,
//                 <SolarPowerIcon />
//               )}
//               {field(
//                 "DC Capacity",
//                 userData.dc_capacity,
//                 <SolarPowerIcon />
//               )}
//               {field("Address", userData.address, <HomeIcon />)}
//               {field("City", userData.city, <LocationCityIcon />)}
//               {field("Currency", userData.currency, <PublicIcon />)}
//               {field("Latitude", userData.lat, <PublicIcon />)}
//               {field("Longitude", userData.long, <PublicIcon />)}

//               {/* RED COLOR */}
//               {field(
//                 "Rate",
//                 userData.rate,
//                 <BusinessIcon />,
//                 "#d32f2f"
//               )}

//               {field(
//                 "CO2 Reduction",
//                 userData.co2_rate,
//                 <SolarPowerIcon />,
//                 "#d32f2f"
//               )}

//               {field(
//                 "Total Modules",
//                 userData.total_modules,
//                 <SettingsInputComponentIcon />
//               )}

//               {field(
//                 "Each Module Capacity",
//                 userData.module_capacity,
//                 <SettingsInputComponentIcon />
//               )}

//               {field("Password", userData.password, <LockIcon />)}

//               {field(
//                 "Module Make",
//                 userData.module_make,
//                 <MdViewModule />
//               )}
//             </Grid>
//           )}

//           {/* UPDATE BUTTON */}
//           <Box sx={{ textAlign: "center", mt: 4 }}>
//             <Button
//               variant="contained"
//               onClick={() => setOpenUpdate(true)}
//               sx={{
//                 backgroundColor: PrimaryColor,
//                 px: 4,
//                 py: 1.8,
//                 borderRadius: 2,
//               }}
//             >
//               Update User Details
//             </Button>
//           </Box>
//         </Box>
//       </Container>

//       {/* UPDATE MODAL */}
//       <UserDetailUpdate
//         show={openUpdate}
//         handleClose={() => setOpenUpdate(false)}
//         userData={userData}
//         onUpdate={(data) => {
//           console.log("Updated Successfully:", data);

//           // refresh data after update
//           fetchLogData();
//         }}
//       />
//     </>
//   );
// };

// export default UserDetails;


// 5.

import React, { useContext, useState, useEffect } from "react";
import {
  Box,
  Paper,
  Typography,
  Grid,
  Container,
  Avatar,
  Button,
} from "@mui/material";

import PersonIcon from "@mui/icons-material/Person";
import BusinessIcon from "@mui/icons-material/Business";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import HomeIcon from "@mui/icons-material/Home";
import SolarPowerIcon from "@mui/icons-material/SolarPower";
import PublicIcon from "@mui/icons-material/Public";
import SettingsInputComponentIcon from "@mui/icons-material/SettingsInputComponent";

import { MdViewModule } from "react-icons/md";

import { AppThemeContext } from "../../../../context/AppThemeContext";
import { AuthenticationContext } from "../../../../context/AuthenticationContext";

import UserDetailUpdate from "./UserDetailUpdate";
import { UserDetailApi } from "../../../../api/Api";

const UserDetails = () => {
  const { PrimaryColor } = useContext(AppThemeContext);
  const { LoggedInUserInfo } = useContext(AuthenticationContext);

  const [logData, setLogData] = useState({});
  const [openUpdate, setOpenUpdate] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const LOGIN_ID = sessionStorage.getItem("LoginID") || "";

  const credentials = {
    LOGIN_ID: LOGIN_ID,
    PASS_KEY: "xyz",
    WEB_KEY: "xyz",
  };

  // FETCH USER DATA
  const fetchLogData = async () => {
    setLoading(true);
    setError("");

    try {
      const res = await UserDetailApi(credentials);

      console.log("API RESPONSE:", res);

      if (res?.USER_DET) {
        // if array
        if (Array.isArray(res.USER_DET)) {
          setLogData(res.USER_DET[0] || {});
        } else {
          // if object
          setLogData(res.USER_DET);
        }
      } else {
        setLogData({});
      }
    } catch (err) {
      console.log(err);
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
  }, []);

  const userData = {
    user_id: LOGIN_ID,
    username: logData?.USER_NAME,
    plant_capacity: logData?.PLANT_CAPACITY,
    dc_capacity: logData?.DC_CAPACITY,
    address: logData?.ADDRESS,
    city: logData?.CITY,
    currency: logData?.CURRENCY,
    lat: logData?.LATITUDE,
    long: logData?.LONGITUDE,
    rate: logData?.RATE,
    co2_rate: logData?.CO2,
    total_modules: logData?.TOTAL_NO_MODULE,
    module_capacity: logData?.EACH_MODULE_CAPACITY,
    module_make: logData?.MODULE_MAKE,
    plant_unit: logData?.AC_Unit,
    dc_unit: logData?.DC_Unit,
  };

  // FIELD CARD
  const field = (label, value, icon, valueColor = "black") => (
    <Grid item xs={12} sm={6} md={4}>
      <Paper
        elevation={4}
        sx={{
          p: 2,
          borderRadius: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
          transition: "0.3s",
          height: "100%",
          "&:hover": {
            transform: "translateY(-6px)",
            boxShadow: 8,
          },
        }}
      >
        <Avatar
          sx={{
            background: `linear-gradient(135deg, ${PrimaryColor}, ${PrimaryColor}99)`,
          }}
        >
          {icon}
        </Avatar>

        <Box sx={{ width: "100%" }}>
          <Typography
            variant="caption"
            sx={{
              color: "gray",
              fontWeight: 600,
              display: "block",
            }}
          >
            {label}
          </Typography>

          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              color: valueColor,
              wordBreak: "break-word",
            }}
          >
            {value || "-"}
          </Typography>
        </Box>
      </Paper>
    </Grid>
  );

  return (
    <>
      <Container maxWidth="lg">
        <Box sx={{ mt: 5 }}>
          {/* HEADER */}
          <Paper
            elevation={6}
            sx={{
              p: 3,
              mb: 4,
              borderRadius: 4,
              textAlign: "center",
              background: `linear-gradient(135deg, ${PrimaryColor}, ${PrimaryColor}99)`,
              color: "white",
            }}
          >
            <Avatar
              sx={{
                width: 70,
                height: 70,
                margin: "auto",
                mb: 1,
                bgcolor: "white",
                color: PrimaryColor,
              }}
            >
              <PersonIcon fontSize="large" />
            </Avatar>

            <Typography variant="h5" sx={{ fontWeight: "bold" }}>
              User Details
            </Typography>
          </Paper>

          {/* LOADING */}
          {loading && (
            <Typography textAlign="center">Loading...</Typography>
          )}

          {/* ERROR */}
          {error && (
            <Typography color="error" textAlign="center">
              {error}
            </Typography>
          )}

          {/* DATA CARDS */}
          {!loading && (
            <Grid container spacing={3}>
              {field("User ID", userData.user_id, <PersonIcon />)}

              {field("User Name", userData.username, <PersonIcon />)}

              {field(
                "Plant AC Capacity",
                `${userData.plant_capacity} ${userData.plant_unit}`,
                <SolarPowerIcon />
              )}

              {field(
                "Plant DC Capacity",
                `${userData.dc_capacity} ${userData.dc_unit}`,
                <SolarPowerIcon />
              )}
              {field("Address", userData.address, <HomeIcon />)}

              {field("City", userData.city, <LocationCityIcon />)}

              {field("Currency", userData.currency, <PublicIcon />)}

              {field("Latitude", userData.lat, <PublicIcon />)}

              {field("Longitude", userData.long, <PublicIcon />)}

              {/* RED COLOR */}
              {field(
                "Electricity Rate",
                userData.rate,
                <BusinessIcon />,
                "#d32f2f"
              )}

              {field(
                "CO2 Reduction Rate",
                userData.co2_rate,
                <SolarPowerIcon />,
                "#d32f2f"
              )}

              {field(
                "Total Modules",
                userData.total_modules,
                <SettingsInputComponentIcon />
              )}

              {field(
                "Each Module Capacity",
                userData.module_capacity,
                <SettingsInputComponentIcon />
              )}

              {field(
                "Module Make",
                userData.module_make,
                <MdViewModule />
              )}
            </Grid>
          )}

          {/* UPDATE BUTTON */}
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Button
              variant="contained"
              onClick={() => setOpenUpdate(true)}
              sx={{
                backgroundColor: PrimaryColor,
                px: 4,
                py: 1.8,
                borderRadius: 2,
                fontWeight: "bold",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: PrimaryColor,
                  opacity: 0.9,
                },
              }}
            >
              Update User Details
            </Button>
          </Box>
        </Box>
      </Container>

      {/* UPDATE MODAL */}
      <UserDetailUpdate
        show={openUpdate}
        handleClose={() => setOpenUpdate(false)}
        userData={userData}
        onUpdate={(data) => {
          console.log("Updated Successfully:", data);

          // refresh data after update
          fetchLogData();
        }}
      />
    </>
  );
};

export default UserDetails;